/**
 * Tell the server when a Flux Agent conversation segment ends, so its energetic summary is
 * produced now instead of after 20 idle minutes: on voice **Stop** (call the returned function)
 * and when the page is being unloaded (`pagehide`). The request is fire-and-forget; the server
 * ignores it while learning is off and when nothing new was said, and the idle sweep still
 * covers a signal that never arrived.
 *
 * @module apps/web/src/components/flux-agent/learning/useConversationEndSignal
 */

import { useCallback, useEffect, type RefObject } from 'react';
import { fluxAgentLearningApi } from '@/lib/fluxAgentLearningApi';

/** Register the page-hide signal for the active conversation and return a manual end trigger. */
export function useConversationEndSignal(activeId: RefObject<string | null>): () => void {
  const end = useCallback(() => {
    if (activeId.current) fluxAgentLearningApi.endConversation(activeId.current);
  }, [activeId]);
  useEffect(() => {
    window.addEventListener('pagehide', end);
    return () => window.removeEventListener('pagehide', end);
  }, [end]);
  return end;
}
